import EnterpriseList from "./EnterpriseList";

export default EnterpriseList;
